import fetch, { NewAxiosRequestConfig } from '@/utils/axios';

/**
 * 获取物流追踪信息
 */
export const queryTrackingInfo = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/tms/express/tracking/detail`, params, config);
};

/**
 * 获取fountain岗位招聘信息接口
 */
export const getRecruitmentInfoList = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/tms/v2/recruitment/getRecruitmentInfoList`, {}, config);
};
